/* --------------------------------------------------
Import modules
-------------------------------------------------- */

import Equalizer from '@meteora-digital/equalizer';

/* --------------------------------------------------
Document Setup
-------------------------------------------------- */

window.equalizers = {};
let index = 0;

// When any of these events are called, equalize the window
const updateEqualizerEvents = ['critical-loaded', 'scripts-loaded'];
const EqualizerWatcher = new Watcher();
const MatchHeightWatcher = new Watcher();

// Add specific selectors here, they will be used to override the default MutationObserver settings and observe the subTree
const subTreeRequirements = ['[data-limit]'];

// The default MutationObserver settings
const mutations = {
  childList: true,
  subtree: false
};

// A function to determine the MutationObserver settings for a given container
function getMutationObserverSettings(container) {
  const settings = Object.assign({}, mutations);

  // Check if the container has any of the subTreeRequirements
  subTreeRequirements.forEach(selector => {
    // If the container has the selector, set the subtree to true
    if (container.querySelector(selector)) settings.subtree = true;
  });
  return settings;
}
function addEqualizer(settings, ID) {
  if (window.equalizers[ID]) ID = `${ID}-${index}`;
  // Set up the equalizer using the settings
  window.equalizers[ID] = new Equalizer(settings);
  index += 1;
}
function equalize() {
  // console.log('Window Equalized:');
  Object.keys(window.equalizers).forEach(key => {
    window.equalizers[key].update();
    // console.log('- ', key);
  });
  updateEqualizerEvents.forEach(event => {
    window.removeEventListener(event, equalize);
  });
}
EqualizerWatcher.on('update', containers => {
  containers.forEach(container => {
    const ID = container.getAttribute('data-equalize');
    addEqualizer({
      container,
      identifiers: ID,
      rows: true,
      mutations: getMutationObserverSettings(container)
    }, ID);
  });
});
MatchHeightWatcher.on('update', containers => {
  containers.forEach(container => {
    const ID = container.getAttribute('data-match-height');
    addEqualizer({
      container,
      identifiers: ID,
      rows: false,
      mutations: getMutationObserverSettings(container)
    }, ID);
  });
});
EqualizerWatcher.watch('[data-equalize]');
MatchHeightWatcher.watch('[data-match-height]');
updateEqualizerEvents.forEach(event => window.addEventListener(event, equalize));